import React, { useEffect } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";

import AuthLayout from "layouts/Auth";
import PortalLayout from "layouts/Portal";
import AccountLayout from "layouts/Account";
import NotFoundLayout from "layouts/NotFound";

import usePortalRedirection from "../hooks/usePortalRedirection";
import { PORTAL_LAYOUT_ROUTE } from "./portal/portalPaths";
import { ACCOUNT_LAYOUT_ROUTE } from "./account/accountPaths";
import {
  AUTH_ROOT_ROUTE,
  LOGIN_ROUTE,
  LOGIN_ROUTE_REDIRECT,
  RECOVER_PASSWORD,
  RECOVER_PASSWORD_REDIRECT,
  RECOVER_JOIN_PASSWORD,
  RECOVER_JOIN_PASSWORD_REDIRECT,
  REGISTER_ROUTE,
  REGISTER_ROUTE_REDIRECT,
  REGISTER_WITH_CODE_ROUTE,
  REGISTER_WITH_CODE_ROUTE_REDIRECT,
  REGISTER_HOME_WITH_CODE_ROUTE_REDIRECT,
} from "./auth/authPaths";

const Routes = () => {
  const location = useLocation();
  const { initialized } = usePortalRedirection(true);

  useEffect(() => {
    window.gtag("set", "page_path", location.pathname);
    window.gtag("event", "page_view");
  }, [location]);

  return initialized ? (
    <Switch>
      <Redirect path="/" to={AUTH_ROOT_ROUTE + LOGIN_ROUTE} exact />
      <Redirect path="/return-to-new-version" to="/" exact />
      <Redirect
        path={LOGIN_ROUTE_REDIRECT}
        to={AUTH_ROOT_ROUTE + LOGIN_ROUTE}
        exact
      />
      <Redirect
        path={REGISTER_ROUTE_REDIRECT}
        to={AUTH_ROOT_ROUTE + REGISTER_ROUTE}
        exact
      />
      <Redirect
        path={RECOVER_PASSWORD_REDIRECT}
        to={AUTH_ROOT_ROUTE + RECOVER_PASSWORD}
        exact
      />
      <Redirect
        path={RECOVER_JOIN_PASSWORD_REDIRECT}
        to={AUTH_ROOT_ROUTE + RECOVER_JOIN_PASSWORD}
        exact
      />
      <Redirect
        path={REGISTER_WITH_CODE_ROUTE_REDIRECT}
        to={AUTH_ROOT_ROUTE + REGISTER_WITH_CODE_ROUTE}
        exact
      />
      <Redirect
        path={REGISTER_HOME_WITH_CODE_ROUTE_REDIRECT}
        to={AUTH_ROOT_ROUTE + REGISTER_WITH_CODE_ROUTE}
        exact
      />
      <Route
        path={AUTH_ROOT_ROUTE}
        render={(props) => <AuthLayout {...props} />}
      />
      <Route
        path={PORTAL_LAYOUT_ROUTE}
        render={(props) => <PortalLayout {...props} />}
      />
      <Route
        path={ACCOUNT_LAYOUT_ROUTE}
        render={(props) => <AccountLayout {...props} />}
      />
      <Route component={NotFoundLayout} />
    </Switch>
  ) : (
    <></>
  );
};

export default Routes;
